import { connectivityService } from '~/data/connectivity/ConnectivityService';
import { appReferenceLocal } from '~/data/local';
import { appReferenceRemote } from '~/data/remote';
import {
  AllUsers,
  Department,
  IssueCategory,
  IssueSortingType,
  Label,
} from '~/types';
import store from '~/store';

export class AppReferenceRepository {
  async loadUsers(): Promise<AllUsers[] | undefined> {
    if (connectivityService.isOnline()) {
      const data = await appReferenceRemote.fetchUsers();
      const userId = store.getState().user?.data?.id;
      const offlineUsers = data.filter((u) => +userId === +u.id);
      await appReferenceLocal.resetUsers(offlineUsers.length ? offlineUsers : data.slice(0, 1));
      return data;
    }
    return appReferenceLocal.getAllUsers();
  }

  async loadDepartments(): Promise<Department[] | undefined> {
    if (connectivityService.isOnline()) {
      const data = await appReferenceRemote.fetchDepartments();
      await appReferenceLocal.resetDepartments(data);
      return data;
    }
    return appReferenceLocal.getAllDepartments();
  }

  async loadIssueCategories(): Promise<IssueCategory[] | undefined> {
    if (connectivityService.isOnline()) {
      const data = await appReferenceRemote.fetchIssueCategories();
      await appReferenceLocal.resetIssueCategories(data);
      return data;
    }
    return appReferenceLocal.getAllIssueCategories();
  }

  async loadIssueSortingTypes(): Promise<IssueSortingType[] | undefined> {
    if (connectivityService.isOnline()) {
      const data = await appReferenceRemote.fetchIssueSortingTypes();
      await appReferenceLocal.resetIssueSortingTypes(data);
      return data;
    }
    return appReferenceLocal.getAllIssueSortingTypes();
  }

  async loadLabels(): Promise<Label[] | undefined> {
    if (connectivityService.isOnline()) {
      const data = await appReferenceRemote.fetchIssueLabels();
      await appReferenceLocal.resetIssueLabels(data);
      return data;
    }
    return appReferenceLocal.getAllIssueLabels();
  }
}

export const appReferenceRepository = new AppReferenceRepository();
